const isAtTop = identifier => {
  let elementHeight = identifier;
  if (typeof identifier === 'string') {
    const elem = document.getElementById(identifier);
    if (elem) elementHeight = elem.offsetTop;
  }
  return window.pageYOffset < elementHeight;
};

const getScrollListener = (identifier, handler) => () => {
  const listenerArgs = ['scroll', () => handler(isAtTop(identifier))];
  // Timeout gives the DOM a chance to load before we evaluate
  setTimeout(() => !isAtTop(identifier) && handler(false), 100);
  window.addEventListener(...listenerArgs);
  return () => window.removeEventListener(...listenerArgs);
};

export default getScrollListener;
